<template>
    <div class="container">
        <div v-if="!qrCode">
            <div class="form-group">
                <label for="exampleInputEmail1" style="font-weight: 500;">Duration</label>
                <input type="number" class="form-control rounded" placeholder="Search" v-model="deviceDeleteInterval" max="30" />
                <small class="text-danger" :style="{ float: 'left' }">All the applications will be removed after the set Interval in minutes.</small>
            </div>
            <div class="input-group rounded">
                <input type="search" class="form-control rounded" placeholder="Search Play Store Applications" aria-label="Search" aria-describedby="search-addon" v-model="searchApplicationText">
                    <span class="input-group-text border-0" id="search-addon">
                        <a href="javascript:void(0)" @click="searchPlayStore()"><i class="fas fa-search"></i></a>
                    </span>
            </div>
            <div class="app-listing-copy" v-if="playstoreApplications.length > 0">
                <br>
                <ul id="product-directory">
                    <li v-for="application in playstoreApplications" :key="application.appId">
                        <img :src="application.icon">
                        <a class="badge-icon" href="javascript:void(0);" @click="addToProfileApplications(application)" >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </a>
                        <div class="app-listing-text">
                            <span class="apptext" title="app.package_name" ><small><b>{{ application.title }}</b></small></span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="app-listing-copy" v-if="profileApplications.length > 0">
                <br>
                <h4><b>Your Applications</b></h4>
                <ul id="product-directory">
                    <li v-for="application in profileApplications" :key="application.appId">
                        <img :src="application.icon">
                        <a class="badge-icon text-danger" href="javascript:void(0);" @click="removeToProfileApplications(application)" >
                            <i class="fa fa-minus" aria-hidden="true"></i>
                        </a>
                        <div class="app-listing-text">
                            <span class="apptext" title="app.package_name" ><small><b>{{ application.title }}</b></small></span>
                        </div>
                    </li>
                </ul>
            </div>
            <div style="text-align: center;margin: 10px;">
                <button type="button" class="btn btn-success" :disabled="isDisabled" @click="generateQrCode()">
                    Generate QR Code<span v-if="showLoader"><i class="fa fa-spinner fa-spin"></i></span></button>
            </div>
        </div>
        <div style="text-align: center;margin-top: 20px;" v-if="qrCode">
            <h4>Scan this QR code : </h4>
            <img :src=qrCode>
            <div style="text-align: center;margin: 10px;">
                <button type="button" class="btn btn-success" @click="gotoPreviousPage()">Go Back</button>
            </div>
        </div>
    </div>
</template>
<script>
import HomeDataService from "../services/HomeDataService";
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
const $toast = useToast();

export default {
  name: 'Disappearing Profile',
  components: {
  },
  data() {
    return {
      isDisabled: true,
      showLoader: false,
      deviceDeleteInterval: 10,
      searchApplicationText: "",
      playstoreApplications: [],
      profileApplications: [],
      loginSuccess: false,
      profile_id: null,
      profile_name: "",
      qrCode:"",
      configuration_name: "",
    };
  },
  methods: {
    searchPlayStore() {
        this.playstoreApplications = []; this.profileApplications = [];
        let data = { app_name: this.searchApplicationText }
        HomeDataService.searchPlayStore(data)
        .then((response) => {
            this.playstoreApplications = response.data.data; 
        })
        .catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    addToProfileApplications(application) {
        this.profileApplications.push(application);
        let updatedplaystoreApplications = this.playstoreApplications.filter(elem => elem.appId != application.appId)   
        this.playstoreApplications = updatedplaystoreApplications;
        this.isDisabled = false;
    },
    removeToProfileApplications(application) {
        let updatedProfileApplications = this.profileApplications.filter(elem => elem.appId != application.appId)   
        this.profileApplications = updatedProfileApplications;
        if (this.profileApplications.length == 0) {
            this.isDisabled = true
        }
    },
    async generateQrCode() {
        this.isDisabled = true;
        this.showLoader = true;
        this.profile_name = Date.now() + '-' + Math.floor(Math.random() * 1000);
        localStorage.removeItem('token');
        var loginData = {
            email: process.env.VUE_APP_DEFAULT_LOGIN_EMAIL,
            password: "Nova2021$", //process.env.VUE_APP_DEFAULT_LOGIN_PASSWORD,
            userAgent: navigator.userAgent
        };
        await HomeDataService.login(loginData)
        .then((response) => {
            localStorage.setItem('token', response.data.data.token);
            this.loginSuccess = true;
        }) .catch((e) => {
            this.isDisabled = false;
            this.showLoader = false;
            $toast.error(e.response.data.respones_msg);
        });
        
        if (!this.loginSuccess) {
            $toast.error("Unable to generate token, please try again later");
            return;
        }
        let data = { profile_name: this.profile_name, exit_passcode: 1234, profile_type: "Android", deviceDeleteInterval: this.deviceDeleteInterval,
             enableProfileDisappearing: true, profile_applications: this.profileApplications, is_custom_android_profile: false }
        await HomeDataService.createProfile(data)
        .then((response) => {
          this.profile_id = response.data.data._id;
          this.configuration_name = "Qr Code For " + this.profile_name;
          //$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.showLoader = false;
          $toast.error(e.response.data.respones_msg);
        });

        if (!this.profile_id) {
            $toast.error("Unable to generate profile, please try again later");
            return;
        }

        let qrCodedata = {
          profile_id: this.profile_id,
          configuration_name: this.configuration_name,
        };
        await HomeDataService.createQrCode(qrCodedata)
        .then((response) => {
          this.qrCode = response.data.byod_qr_code_url;
          $toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.showLoader = false;
          $toast.error(e.response.data.respones_msg);
        });
        this.isDisabled = false;
        this.showLoader = false;
    },
    gotoPreviousPage() {
        this.profileApplications = [];
        this.qrCode = "";
        return this.$router.push({ path: '/'});
    },
  },
  beforeMount() {
    this.searchApplicationText = "Tabnova";
    this.searchPlayStore();
  },
}
</script>

<style>
body {
    background-color: #f6f7f8;
}
/*.footer {
    position: fixed;
    bottom: 0;
    width: 100%;
}*/
.fa-plus {
    color: black;
}
.app-listing-copy {
    overflow: auto;white-space: nowrap;
}
.app-listing-text {
    width: 135px !important;word-wrap: break-word !important;white-space: normal;
}
.badge-icon {
    position: absolute;
    top: 0px;
    right: 10px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #c5f1c9;
    border-radius: 5px;
    font-size: 14px;
}

#product-directory {
    padding: unset;
    box-sizing: border-box;
}
#product-directory ul {
    padding-left: 0;
    box-sizing: border-box;
}
#product-directory li {
    list-style: none;
    box-sizing: border-box;
    display: inline-block;
    width: 140px;
    margin: 5px;
    position: relative;            
    border: 1px solid #d3d3d3;
    align-content: center;
    display: inline-block; 
    vertical-align: top;
}
#product-directory li img {
    max-width: 65%;
    height: 85px;
    margin: 0 auto;
    position: relative;
    align-self: center;
    margin:0 auto;
    display:block;
}
#product-directory li span {
    display: block;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    /*background-color: #6a6969;*/
    padding: 5px;
    color: black;
    min-height: 34px;
    word-break: break-all;
    height: 75px;
}
</style>